import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { QuotationService } from '../quotation.service'
import { ToastrService } from 'ngx-toastr'
import { NavigationEnd, Router } from '@angular/router'
import { QuotationModel } from '../models/quotation.model'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms'
import { QuotationDetailsComponent } from './viewQuotationDetailComponents/quotationDetails/quotationDetails.component'
import { FollowupComponent } from './viewQuotationDetailComponents/followup/followup.component'
import { ContactClientComponent } from './viewQuotationDetailComponents/contactClient/contactClient.component'
import { OtherquotationsComponent } from './viewQuotationDetailComponents/otherQuotations/otherQuotations.component'
import { MasterCommonServices } from '../master.common.service'
import { AuthStateService } from '../../../auth-state.service'

@Component({
  selector: 'app-view-quotation-detail',
  standalone: true,
  imports: [
    CommonModule,
    QuotationDetailsComponent,
    ContactClientComponent,
    FollowupComponent,
    FormsModule,
    ReactiveFormsModule,
    OtherquotationsComponent,
  ],
  templateUrl: './viewQuotationDetail.component.html',
  styleUrl: './viewQuotationDetail.component.css',
})
export class ViewQuotationDetailComponent implements OnInit {
  quotationForm: FormGroup = new FormGroup({})
  activeTab: string = 'details'
  isLoading: boolean = false
  submitted: boolean = false
  isToastrShown: boolean = false
  currentPriority: number = 0
  mode: string = 'add'
  quotationData: QuotationModel | undefined
  otherQuotations: QuotationModel[] | undefined
  quotationCommonServices: MasterCommonServices | undefined
  permissions: string[] = []
  quotationTermsNames: any = {}
  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private masterCommonService: MasterCommonServices,
    private quotationService: QuotationService,
    private router: Router,
    private authStateService: AuthStateService,
  ) {
    this.initializeForm()
    this.quotationCommonServices = masterCommonService
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const navigation = this.router.getCurrentNavigation()
        if (navigation?.extras?.state) {
          const params = navigation.extras.state

          this.mode = params['mode'] || 'add'
          if (params['quotationFields']) {
            this.quotationData = {
              quotationFields: JSON.parse(params['quotationFields']),
              quotationItems: JSON.parse(params['quotationItems']),
              quotationTerms: JSON.parse(params['quotationTerms']),
            }
          }

          if (this.quotationData) {
            this.quotationForm.patchValue({
              importance: this.quotationData.quotationFields
                .quotationImportance,
              status: this.quotationData.quotationFields.quotationStatus || 'open',
              reason: this.quotationData.quotationFields.quotationCloseReasonId,
            })
          }
          this.activeTab = 'details'
        }
      }
    })
    this.authStateService.permissions.subscribe((permList) =>{
      this.permissions = permList
    })
    this.quotationForm.get('status')?.valueChanges.subscribe((value) => {
      this.toggleReasonField(value)
    })
  }
  ngOnInit(): void {
    if (this.masterCommonService.isDataLoaded == false) {
      this.masterCommonService.getAllMasters()
    }
    this.getQuotationTermsName().then((data) => {
      this.quotationTermsNames = data
    });
    this.quotationService.getAllQuotations().subscribe({
      next: (data: QuotationModel[]) => {
        this.otherQuotations = data

        this.otherQuotations = this.otherQuotations.filter(
          (quotation) =>
            {
              return quotation.quotationFields.quotationCompanyId ===
                this.quotationData?.quotationFields.quotationCompanyId
            },
        )
      },
    })
  }

  initializeForm() {
    this.quotationForm = this.formBuilder.group({
      importance: [''], // default value
      status: [{value: 'open', }], // default value
      reason: [{ value: '', disabled: true }], // default value, disabled by default
    })
  }

  changeActiveTab(tab: string): void {
    

    this.activeTab = tab
  }

  async getQuotationTermsName() {
    if (this.masterCommonService.isDataLoaded == false) {
      await this.masterCommonService.getAllMasters()
    }
    if (this.quotationData) {
      return {
        currencyName: this.masterCommonService.getCurrencyName(
          this.quotationData.quotationTerms.currencyId,
        ),
        packingType: this.masterCommonService.getPackingTypeName(
          this.quotationData.quotationTerms.packingTypeId,
        ),
        deliveryTime: this.masterCommonService.getDeliveryTimeName(
          this.quotationData.quotationTerms.deliveryTimeId,
        ),
        deliveryName: this.masterCommonService.getDeliveredToName(
          this.quotationData.quotationTerms.deliveryNameId,
        ),
        paymentName: this.masterCommonService.getPaymentTypeName(
          this.quotationData.quotationTerms.paymentId,
        ),
        mtcTypeName: this.masterCommonService.getMtcTypeName(
          this.quotationData.quotationTerms.mtcTypeId,
        ),
        validityName: this.masterCommonService.getValidityName(
          this.quotationData.quotationTerms.validityId,
        ),
        countryName: this.masterCommonService.getCountryName(
          this.quotationData.quotationTerms.countryofOriginId,
        ),
      }
    }
    return {}
  }

  updateDetails() {
    if (this.quotationData?.quotationFields) {
      this.quotationData.quotationFields.quotationStatus = this.quotationForm.get(
        'status',
      )?.value
      this.quotationData.quotationFields.quotationCloseReasonId = this.quotationForm.get(
        'reason',
      )?.value
      this.quotationData.quotationFields.quotationImportance = this.quotationForm.get(
        'importance',
      )?.value
      const quotationModel: QuotationModel = {
        quotationFields: this.quotationData.quotationFields,
        quotationItems: this.quotationData.quotationItems,
        quotationTerms: this.quotationData.quotationTerms,
      }
      this.quotationService.updateQuotation(quotationModel).subscribe({
        next: () => {
          this.toastr.success('Details Updated Successfully!', 'Success')
          let index = this.otherQuotations?.findIndex(
            (quot) =>
              quot.quotationFields.id === quotationModel.quotationFields.id,
          )
          if (
            index != undefined &&
            this.otherQuotations != undefined &&
            index != -1
          ) {
            this.otherQuotations[index] = quotationModel
          }
        },
        error: (error: any) => {
          this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
        },
      })
    }
  }

  toggleReasonField(statusValue: string): void {
    const reasonControl = this.quotationForm.get('reason')
    if (statusValue === 'closed') {
      reasonControl?.enable()
    } else {
      reasonControl?.disable()
      reasonControl?.reset() // Reset reason if status is not closed
    }
  }

  hasPermission(): boolean {
    return this.permissions.includes('QuotationsAddNewPermission')
  }
}
